
import OrderApiConfig from '@/api/OrderApiConfig';
import { DPApi, PostConfirmPayRequest, JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest } from '@/openapi/order';
import { Component, Vue } from 'vue-property-decorator';
import Icon from '@/layouts/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class Payc01View extends Vue {
  mounted(): void {
    const param = (this.$route.query.param as string) ?? '';
    if (!param) {
      this.forwartOrdc01Fail();
      return;
    }

    const config = OrderApiConfig.newInstance();
    const apiOrder = new DPApi(config);
    const body: JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest = {
      userAgent: window.navigator.userAgent.toLowerCase(),
    };
    const request: PostConfirmPayRequest = {
      p: param,
      jpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest: body,
    };
    apiOrder
      .postConfirmPay(request)
      .then((res) => {
        this.$router.push({
          name: 'Ordc01',
          params: {
            status: 'Success',
            confirmPayPostResponse: res as string,
          },
        });
      })
      .catch(() => {
        this.forwartOrdc01Fail();
      });
  }

  private forwartOrdc01Fail() {
    this.$router.push({
      name: 'Ordc01',
      params: { status: 'Fail' },
    });
  }
}
